var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('h4',[_vm._v("\n    Form Builder\n    "),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":{ name: 'form-builder.create' }}},[_vm._v("Create\n    ")])],1),_c('form-builder-base-table',{attrs:{"resource":_vm.resource},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])]}},{key:"categories",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s((function (categories) {
          var a = [];

          if (typeof categories === "undefined") { return []; }

          for (var i = 0; i < categories.length; i++) {
            a.push(categories[i].title)
          }

          return a;
        })(item.categories).join(' | '))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }